module.exports = __webpack_public_path__ + "img/LogoNovo-Retextoar-branco.9be1b2f7.png";